// extracted by mini-css-extract-plugin
export default {"root":"MainLayout_root__XAGmw","sidebar":"MainLayout_sidebar__OnRjX","content":"MainLayout_content__Gqsoj","noPadding":"MainLayout_noPadding__44I-j"};